var avImageBannerCrossfadeItems = [];
var avImageBannerCrossfadeTicking = false;

function avImageBannerUpdateCrossfade() {
  avImageBannerCrossfadeItems.forEach(function (banner) {
    var triggerPercent = parseFloat(banner.dataset.avBannerCrossfadeTrigger);
    if (isNaN(triggerPercent)) triggerPercent = 50;
    var triggerLine = window.innerHeight * (triggerPercent / 100);

    var rect = banner.getBoundingClientRect();
    var bannerCenter = rect.top + rect.height / 2;
    banner.classList.toggle('is-flipped', bannerCenter <= triggerLine);
  });

  avImageBannerCrossfadeTicking = false;
}

function avImageBannerRequestCrossfadeUpdate() {
  if (avImageBannerCrossfadeTicking) return;
  avImageBannerCrossfadeTicking = true;
  window.requestAnimationFrame(avImageBannerUpdateCrossfade);
}

function initAvImageBannerCrossfade() {
  // Re-collect items fresh every call (editor may have added/removed banners), but only ever
  // bind the scroll/resize listeners once globally.
  avImageBannerCrossfadeItems = [];
  document.querySelectorAll('[data-av-banner-crossfade]').forEach(function (banner) {
    avImageBannerCrossfadeItems.push(banner);
  });

  if (!avImageBannerCrossfadeItems.length) return;

  avImageBannerRequestCrossfadeUpdate();

  if (!window.__avImageBannerCrossfadeBound) {
    window.__avImageBannerCrossfadeBound = true;
    window.addEventListener('scroll', avImageBannerRequestCrossfadeUpdate, { passive: true });
    window.addEventListener('resize', avImageBannerRequestCrossfadeUpdate);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAvImageBannerCrossfade);
} else {
  initAvImageBannerCrossfade();
}

document.addEventListener('shopify:section:load', initAvImageBannerCrossfade);
